module.exports = __webpack_public_path__ + "static/media/excel.89c60acd.png";